const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import type { LucideIcon } from 'lucide-react';
import { type ProPatient } from '@/context/ProIntakeContext';

/** Shape of data submitted from IntakeModal / EmergencyIntakeModal */
interface IntakeFormData {
  species?: string;
  petName?: string;
  ownerName?: string;
  ownerEmail?: string;
  ownerPhone?: string;
  breedKey?: string;
  lastVisit?: string;
  nextVaccineDueNow?: boolean;
  nextVaccineDate?: string;
  petDid?: string;
  microchip?: string;
  emergencyType?: string;
}
export const Route = createFileRoute('/dashboard')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/** Small standalone component — avoids variable-scope issues in the large dashboard chunk */

/** Shows the member's assigned branch name — must be inside LocationProvider */

/** Color map for navigation group border + label */

interface NavTab {
  id: string;
  path: string;
  label: string;
  icon: LucideIcon;
}
interface NavGroup {
  label: string;
  color: string;
  tabs: NavTab[];
  row?: 1 | 2;
}

/** Small amber pill badge — shared by Service Requests badge spots */

/** Single category button with dropdown */